import { afterNextRender, inject, Injectable, Injector } from '@angular/core';
import { BdUtilScriptService } from '@bindoc-projects/util-lib/data';
import { DOCUMENT } from '@angular/common';
import {
  CCM19_SCRIPT_BASE_URL,
  USER_COOKIE_CCM19_API_KEY,
} from '../ccm19.config';

@Injectable({
  providedIn: 'root',
})
export class BdUserCookieService {
  private readonly _document = inject(DOCUMENT);
  private readonly _apiKey = inject(USER_COOKIE_CCM19_API_KEY);
  private readonly _scriptService = inject(BdUtilScriptService);
  private readonly _injector = inject(Injector);

  public init(domainId: string): void {
    afterNextRender(
      () => {
        this._scriptService.loadJsScript(
          {
            id: 'CCM19',
            src: `${CCM19_SCRIPT_BASE_URL}?apiKey=${this._apiKey}&amp;domain=${domainId}`,
          },
          [['referrerpolicy', 'origin']],
          this._document.head,
        );
      },
      { injector: this._injector },
    );
  }
}
